import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_DISH_TYPE_SIMPLE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateDishTypeSimpleDetailsArgs } from '../graphql/transformers'
import { UPDATE_DISH_TYPE_SIMPLE_DETAILS } from '../redux/action-types'

const useUpdateDishTypeDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isSimpleDetailsLoading, simpleDetailsError } = useSelector(
    store => store.dishTypes.dishType,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_DISH_TYPE_SIMPLE_DETAILS_MUTATION,
        { id, data: transformToUpdateDishTypeSimpleDetailsArgs(data) },
        dispatch,
        UPDATE_DISH_TYPE_SIMPLE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isSimpleDetailsLoading, error: simpleDetailsError },
  ]
}

export default useUpdateDishTypeDetailsMutation
